const h = "0.5.0";
let o = null, c = null, l = null;
const k = {
  status: "SIGNED_OUT",
  maskedPhone: null,
  profileComplete: !1,
  riderCount: 0,
  outstandingRequiredConsents: 0,
  expiresAt: null
};
function p(t, e = window.location) {
  const n = "/pages/lrc-account";
  if (!t || /^\s*javascript:/i.test(t)) return n;
  try {
    const a = new URL(t, e.origin);
    return a.origin !== e.origin || !a.pathname.startsWith("/") ? n : `${a.pathname}${a.search}${a.hash}`;
  } catch {
    return n;
  }
}
async function w(t = {}) {
  if (!t.enabled || !t.customerAccountEnabled || o || c) return;
  const e = t.targetId ?? "lrc-quick-root";
  let n = document.getElementById(e);
  n || (n = document.createElement("div"), n.id = e, n.dataset.lrcQuickOwned = "true", document.body.append(n), l = n);
  const a = n, d = p(t.accountUrl);
  document.documentElement.dataset.lrcAccountUrl = d, c = import("./lrc-quick.index.CJjUxa1w.js").then(
    ({ mountLrcQuick: f }) => f(a, {
      apiBaseUrl: t.apiBaseUrl ?? window.location.origin,
      shopDomain: t.shopDomain ?? window.location.hostname,
      bootstrapPath: t.bootstrapPath ?? "/apps/lrc/customer-auth/bootstrap",
      customerAccountEnabled: !0,
      showAccountTrigger: t.showAccountTrigger ?? !0,
      accountTriggerLabel: t.accountTriggerLabel ?? "Parent login",
      mode: t.mode ?? "overlay",
      accountUrl: d,
      heading: t.heading ?? "My LRC Account",
      checkoutMode: "SHOPIFY_CHECKOUT_HANDOFF"
    })
  ).catch(() => (a.innerHTML = '<div class="lrcq-alert" role="alert">The LRC account could not be loaded. Please refresh and try again.</div>', null)), o = await c, c = null, a.dataset.lrcQuickMounted = o ? "true" : "false";
  const m = u(window.location.href);
  if (m) {
    window.sessionStorage.setItem("lrc:commerce-intent", m), window.location.replace("/");
    return;
  }
  const s = window.sessionStorage.getItem("lrc:commerce-intent");
  o && (s === "cart" || s === "checkout") && (window.sessionStorage.removeItem("lrc:commerce-intent"), s === "cart" ? await o.openCart() : await o.openCheckout()), t.debug && (a.dataset.lrcQuickVersion = h);
}
async function r() {
  if (!o && !c) {
    const t = document.querySelector("lrc-header-account[data-mount-target]"), e = t?.dataset.mountTarget;
    t && e && await w({
      enabled: !0,
      customerAccountEnabled: !0,
      targetId: e,
      apiBaseUrl: t.dataset.apiBaseUrl ?? window.location.origin,
      shopDomain: t.dataset.shopDomain ?? window.location.hostname,
      bootstrapPath: "/api/v1/customer-auth/bootstrap",
      showAccountTrigger: !1,
      mode: "overlay",
      accountUrl: t.dataset.accountUrl ?? "/pages/lrc-account",
      heading: "My LRC Account"
    });
  }
  if (c && await c, !o) throw new Error("LRCQuick must be mounted first");
  return o;
}
async function C() {
  c && await c, o?.unmount(), o = null, l?.remove(), l = null;
}
const i = {
  mount: w,
  unmount: C,
  openLogin: async () => (await r()).openLogin(),
  openCart: async () => (await r()).openCart(),
  openCheckout: async () => (await r()).openCheckout(),
  openAccount: async () => (await r()).openAccount(),
  logout: async () => (await r()).logout(),
  getAuthState: () => o?.getAuthState() ?? { ...k },
  getVersion: () => h,
  getAccountUrl: () => p(document.documentElement.dataset.lrcAccountUrl),
  navigateToAccount: () => window.location.assign(i.getAccountUrl())
};
window.LRCQuick = i;
function u(t) {
  try {
    const e = new URL(t, window.location.origin).pathname.replace(/\/+$/, "") || "/";
    if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart$/i.test(e)) return "cart";
    if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkout$/i.test(e) || e.startsWith("/checkouts/"))
      return "checkout";
  } catch {
    return null;
  }
  return null;
}
function g(t) {
  if (t.closest('[data-lrc-checkout], [name="checkout"]')) return "checkout";
  if (t.closest("[data-lrc-cart]")) return "cart";
  const e = t.closest("a[href]");
  return e ? u(e.href) : null;
}
document.addEventListener(
  "click",
  (t) => {
    if (!(t.target instanceof Element) || t.target.closest(".lrcq-commerce-portal")) return;
    const e = g(t.target);
    e && (t.preventDefault(), t.stopImmediatePropagation(), e === "cart" ? i.openCart().catch((n) => console.error("[LRCQuick] cart open failed", n)) : i.openCheckout().catch(
      (n) => console.error("[LRCQuick] checkout open failed", n)
    ));
  },
  !0
);
document.addEventListener(
  "submit",
  (t) => {
    if (!(t instanceof SubmitEvent)) return;
    const e = t.submitter, n = t.target;
    !(n instanceof HTMLFormElement) || (e instanceof Element ? g(e) ?? u(n.action) : u(n.action)) !== "checkout" || (t.preventDefault(), t.stopImmediatePropagation(), i.openCheckout());
  },
  !0
);
export {
  i as LRCQuick,
  g as commerceElementIntent,
  u as commercePathIntent,
  p as safeAccountPath
};
